import { FC } from 'react';
import { FiBarChart } from 'react-icons/fi';
import { TSTitleCard } from '../../../../components/shared/card/Card';
import { useAdvancedLeaveDataForEmployee } from '../../../../services/staff/advancedLeave';
import { SummaryDay } from '../../../../services/summary/summary.types';
import { strings } from '../../../../services/translation/strings';

interface TeamMemberAnnualLeaveCardProps {
  dateString: string;
  employeeSchedule: SummaryDay[];
}

export const TeamMemberAnnualLeaveCard: FC<TeamMemberAnnualLeaveCardProps> = ({ dateString, employeeSchedule }) => {
  const { advancedLeaveData } = useAdvancedLeaveDataForEmployee(employeeSchedule);

  return (
    <TSTitleCard
      className="bg-white"
      title={strings.timeshift.teamMember.annualLeave.cardTitle(dateString)}
      icon={FiBarChart}
    >
      <div className="lg:m-4 border rounded-lg">
        <div className="grid grid-cols-4">
          <span className="p-2 font-semibold">{strings.timeshift.teamMember.annualLeave.leaveType}</span>
          <span className="p-2 font-semibold">{strings.timeshift.teamMember.annualLeave.total}</span>
          <span className="p-2 font-semibold">{strings.timeshift.teamMember.annualLeave.minimum}</span>
          <span className="p-2 font-semibold">{strings.timeshift.teamMember.annualLeave.maximum}</span>
        </div>
        {advancedLeaveData.map(leaveType => {
          return (
            <div className="grid grid-cols-4 even:bg-gray-200" key={leaveType.id}>
              <span className="p-2">{leaveType.properties.displayName || leaveType.name}</span>
              <span className="p-2">
                {employeeSchedule.filter(day => day.leaveType && day.leaveType === leaveType.id).length}
              </span>
              <span className="p-2">{leaveType.limitSettings.min.value}</span>
              <span className="p-2">{leaveType.limitSettings.max.value}</span>
            </div>
          );
        })}
      </div>
    </TSTitleCard>
  );
};
